import { Helmet } from "react-helmet-async";

const SITE_URL = "https://kurpfalz-automation.de";
const DEFAULT_IMAGE = `${SITE_URL}/logo-kurpfalz-automation.png`;

/**
 * Per-page title/description/canonical/OG/Twitter + optional JSON-LD.
 * Renders into <head> via react-helmet-async, which react-snap captures
 * into the static HTML at prerender time.
 */
export const Seo = ({ title, description, path = "/", image = DEFAULT_IMAGE, jsonLd = [], noindex = false }) => {
  const url = `${SITE_URL}${path}`;
  const schemas = Array.isArray(jsonLd) ? jsonLd : [jsonLd];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, follow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Kurpfalz Automation" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="de_DE" />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
